import { Routes } from '@angular/router';

export const NoSidenavLayout_ROUTES: Routes = [

  {
    path: 'organization_dash',
    loadChildren: () => import('../../modules/dashboard/organization-dash/organization-dash.module').then(m => m.OrganizationDashModule),
  },
  {
    path: 'manage_Orders',
    loadChildren: () => import('../../modules/manage-orders/manage-orders.module').then(m => m.ManageOrdersModule),
  },
  {
    path: 'manage_Orders/manageorderdetails',
    loadChildren: () => import('../../modules/manage-orders/manage-orders.module').then(m => m.ManageOrdersModule),
  },
  {
    path: 'products/:id',
    loadChildren: () => import('../../modules/dashboard/organization-dashboard/products/products.module').then(m => m.ProductsModule),
  },
  {
    path: 'cart',
    loadChildren: () => import('../../modules/dashboard/organization-dashboard/cart/cart.module').then(m => m.CartModule),
  },
  {
    path: 'team_dash',
    loadChildren: () => import('../../modules/dashboard/team-dash/team-dash.module').then(m => m.TeamDashModule),
  },
  {
    path: 'restaurant_dash',
    loadChildren: () => import('../../modules/dashboard/restaurant-dash/restaurant-dash.module').then(m => m.RestaurantDashModule),
  },

  {

    path: 'cart',

    loadChildren: () => import('../../modules/dashboard/organization-dashboard/cart/cart.module').then(m => m.CartModule),

  },

  {
    path: 'players_payment',
    loadChildren: () => import('../../modules/dashboard/organization-dashboard/players-payment/players-payment.module').then(m => m.PlayersPaymentModule),
  },

  {
    path: 'preview_restaurant_items',
    loadChildren: () => import('../../modules/preview/preview.module').then(m => m.PreviewModule),
  },


]
